<button [matMenuTriggerFor]="treeMenu">
  {{title}}
</button>
<mat-menu #treeMenu="matMenu" backdropClass="menu-container">
  <div [style]="'max-height: ' + maxHeight + 'px; overflow-y: scroll; padding-right: 20px'">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
        <button mat-icon-button disabled></button>
        <ng-container *ngIf="!allowSelect">{{node.item}}</ng-container>
        <mat-checkbox *ngIf="allowSelect" class="checklist-leaf-node"
                      [checked]="nodeIsSelected(node)"
                      (change)="toggleSelection(node)">{{node.item}}
        </mat-checkbox>
      </mat-tree-node>
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
        <span class="fas" [ngClass]="{
        'fa-angle-right': !treeControl.isExpanded(node),
        'fa-angle-down': treeControl.isExpanded(node)
        }"></span>
        </button>
        <ng-container *ngIf="!allowSelect">{{node.item}}</ng-container>
        <mat-checkbox *ngIf="allowSelect"
                      (click)="$event.stopPropagation()"
                      [checked]="descendantsAllSelected(node)"
                      [indeterminate]="descendantsPartiallySelected(node)"
                      (change)="toggleSelection(node)">{{node.item}}
        </mat-checkbox>
      </mat-tree-node>
    </mat-tree>
  </div>
</mat-menu>
<!--
<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{title}}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div [style]="'max-height: ' + maxHeight + 'px; overflow-y: scroll;'">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
      <button mat-icon-button disabled></button>
      <ng-container *ngIf="!allowSelect">{{node.item}}</ng-container>
      <mat-checkbox *ngIf="allowSelect" class="checklist-leaf-node"
                    [checked]="nodeIsSelected(node)"
                    (change)="toggleSelection(node)">{{node.item}}
      </mat-checkbox>
    </mat-tree-node>
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
        <span class="fas" [ngClass]="{
        'fa-angle-right': !treeControl.isExpanded(node),
        'fa-angle-down': treeControl.isExpanded(node)
        }"></span>
      </button>
      <ng-container *ngIf="!allowSelect">{{node.item}}</ng-container>
      <mat-checkbox *ngIf="allowSelect"
                    [checked]="descendantsAllSelected(node)"
                    [indeterminate]="descendantsPartiallySelected(node)"
                    (change)="toggleSelection(node)">{{node.item}}
      </mat-checkbox>
    </mat-tree-node>
  </mat-tree>
  </div>
</mat-expansion-panel>
-->
